import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap } from 'react-icons/fi';
import { Link, useParams } from 'react-router-dom';


import { MdError } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../../components/Forms/Input';
import Button from '../../../../components/Forms/Button';
import Loader from '../../../../components/Loader';
import MaskedInput from '../../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../../components/ResponseMessage';
import getValidationErrors from '../../../../utils/getValidationErrors';
import { Error, Separator, Container, FixedResponse } from './styles';
import SelectSimple from '../../../../components/Forms/SelectSimple';
import Whatsapp from '../../../../components/WhatsAppCompartilhar';

import JsonListMultiple from '../../../../components/Forms/JsonListMultiple';

import api from '../../../../services/api';
import { authTitle, defaultProjectHash, eventName, recaptchaKey, urlWebsite } from '../../../../config';
import getCep from '../../../../services/cep';
import { FaBuilding, FaGenderless, FaIdBadge, FaPhone } from 'react-icons/fa';
import CheckboxInput from '../../../../components/Forms/CheckboxInput';
import { useLanguage } from '../../../../hooks/Language';
import TextareaInput from '../../../../components/Forms/TextareaInput';
import { areas } from './areas';
import CheckboxIncluder from './components/CategoryChange';
import { modalidade } from './modalidade';
import { useToast } from '../../../../hooks/Toast';
import { useModal } from '../../../../hooks/Modal';
import CheckboxInputJSON from '../../../DashboardPages/core/components/Forms/CheckboxInputJson';
import { sub } from 'date-fns';


interface IRecoverFormData {
  [key: string]: any
}

interface ICaptcha {
  getValue(): string;
}

interface IOption {
  label: string;
  value: string;
  id: string;
}

const MonitorSubscription: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(true);
  const formRef = useRef<FormHandles>(null);
  const { hash, projectHash = defaultProjectHash } = useParams<Record<string, any>>();
  const [submissionData, setSubmissionData] = useState<Record<string, any>>({});
  const recaptchaRef = useRef(null);
  const { translate } = useLanguage();
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
  const { addToast } = useToast();
  const [haveAgency, setHaveAgency] = useState('Não');
  const [activeReview, setActiveReview] = useState(false);

  const [category, setCategory] = useState([]);
  const [area, setArea] = useState('');
  const [subarea, setSubarea] = useState('');
  const [countryISO, setCountryISO] = useState('BR');

  const [categoryOptions, setCategoryOptions] = useState<Array<IOption>>([]);
  const [areaOptions, setAreaOptions] = useState<Array<IOption>>([]);
  const [subareaOptions, setSubareaOptions] = useState<Array<IOption>>([]);

  const [initialData, setInitialData] = useState({});

  const [submission, setSubmission] = useState<Record<string, any>>();

  const hours = submission?.monitor_hour_fields?.reduce((prev, item) => {

    if (item?.options?.length > 0) {

      item?.options?.map(avaliableHour => {

        prev.push({ id: `${avaliableHour}`, label: `${avaliableHour}`, value: { hour: avaliableHour } });


      })

    }

    return prev

  }, [])


  const loadSubmission = async () => {


    const response = await api.get(`/get-submission-selection/${projectHash}/36-simposio-de-oftalmologia-do-hcpa`);

    if (response?.data) {
      setSubmission(response?.data);

    }

  }


  useEffect(() => {

    const areaOptions: Array<IOption> = [];

    areas.map(a => {
      areaOptions.push({ label: a.title, value: a.title, id: a.title });
    })

    setCategoryOptions(areaOptions);

    loadSubmission();


  }, [hash])



  useEffect(() => {

    const areaOptions: Array<IOption> = [];

    areas.map(a => {
      areaOptions.push({ label: a.title, value: a.title, id: a.title });
    })

    setCategoryOptions(areaOptions);

  }, [])


  const box = (dataInfo, key = '') => {
    if (!dataInfo) {
      return <></>
    }
    return <>
      {dataInfo.map(d => <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{key === 'self' ? d || '' : d?.[key] || ''}</aside>)}
    </>
  }


  const checkCategoria = (category, area) => {

    const categoryList = area.finIndex(a => a.title === category);

    if (!category) {
      addToast({ title: 'Campo categoria de submissão é obrigatório' });
      setLoading(false);
      return;
    }

  }

  const handleNewLogin = async (data: IRecoverFormData) => {




    setLoading(true);





    if (data?.hours?.length < submission?.monitor_hour_fields?.[0]?.minimun) {
      addToast({ title: `Selecione ao menos ${submission?.monitor_hour_fields?.[0]?.minimun} horário(s)`, type: 'error' });
      setLoading(false);
      return;
    }


    try {
      formRef.current?.setErrors({});





      const shape: Record<string, any> = {
        name: Yup.string().required('O campo Nome do autor é obrigatório'),
        document_number: Yup.string().required('O campo CPF é obrigatório'),
        company: Yup.string().required('O campo Instituição é obrigatório'),
        email: Yup.string().required('O campo Email do autor é obrigatório'),



      };





      const schema = Yup.object().shape(shape);

      await schema.validate(data, { abortEarly: false });



      if (!activeReview) {
        setSubmissionData(data);
        setActiveReview(true);
        setLoading(false);
        return;
      }




      const response = await api.post(`/signup-monitor/${projectHash}/36-simposio-de-oftalmologia-do-hcpa`, {
        ...data,
        project_id: projectHash

      });

      setSuccess(true);
      setLoading(false);
      window.scrollTo(0, 0)
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (formRef && formRef.current && formRef.current.setErrors) {
          formRef.current.setErrors(errors);
        }
        setLoading(false);

        const errorsString = Object.keys(errors).reduce(
          (prev: Array<string>, key: string): Array<string> => {
            prev = [...prev, errors[key]];
            return prev;
          },
          [],
        );

        setErrorMessage(errorsString);

        return;
      }

      setActiveReview(false);

      setErrorMessage([
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Erro ao gerar seu cadastro',
      ]);
    }
    setLoading(false);
  };

  const [categoryValue, setCategoryValue] = useState('');
  const { addModal } = useModal();

  const getOrientacoes = () => {

    addModal({
      theme: "whiteModal", title: "ORIENTAÇÕES PARA A INSCRIÇÃO DE AVALIADORES", content: <p>



        1.1 Acessar o link para inscrição de avaliadores e preencher as informações solicitadas indicando 1 ou mais categorias em que atua: ensino, pesquisa e extensão e duas ou mais subáreas específicas dentro de cada categoria quando houver e preferência de turno para a participação na banca de apresentação oral dos trabalhos.
        <br /><br />  1.2 Os avaliadores que forem orientadores dos programas de Ensino (PID-UFCSPA) vigência 2022, de Iniciação Científica e Tecnológica da UFCSPA (PIBIC-CNPq, PIBIC-Af-CNPq, PIC-UFCSPA, PROBIC-Fapergs, PROBITI-Fapergs) vigência 2021-2022 e/ou de Extensão (PROBEXT-UFCSPA) vigências 2022 devem inscrever-se em todas as áreas que atuem como orientadores segundo o que determina o Programa ao qual estão vinculados.
        <br /><br />   1.3 A VIII Encontro Internacional de Neonatologia e VI Simpósio Interdisciplinar de Atenção ao Prematuro ocorrerá de 07 a 09/11/22 de forma presencial, a apresentação oral dos trabalhos ocorrerá nos turnos manhã (9-11:30h), tarde (14-16:30h) e noite (18:30-21h). Os professores avaliadores devem indicar pelo menos dois turnos para avaliação dos trabalhos da Mostra nos dias 07, 08 e 09/11/22.
        <br /><br />   1.4 Os avaliadores terão acesso aos resumos com antecedência.
        <br /><br />   1.5 Durante a sessão de apresentação os avaliadores deverão avaliar o resumo e a apresentação oral segundo os seguintes parâmetros: adequação às normas de elaboração do resumo; título adequado ao objeto de trabalho; delimitação dos objetivos; adequação da metodologia aos objetivos propostos; adequação dos resultados obtidos/esperados aos objetivos propostos) e apresentação oral (postura, linguagem e qualidade dos slides; clareza e objetividade; domínio do assunto; cumprimento do tempo).

      </p>
    })


  }

  const [ended, setEnded] = useState(false);

  if (ended) {
    return <Container style={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>

      <h2 style={{ background: 'rgb(0,14,64)', color: '#fff', padding: '15px', marginBottom: '15px' }}>Inscrições de monitor encerrada</h2>
      <Link to={`/`}><Button>Voltar para o site</Button></Link>
    </Container>
  }

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside style={{
        width: '100%',
        padding: '20px'
      }}>
        {success ? (<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <ResponseMessage
            active
            type="success"
            title="Sucesso"
            description={
              <><p style={{ color: '#333' }}>
                Cadastro realizado com sucesso!
                <br />


              </p>
                <aside style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <Link to={`/`} style={{ width: 'auto' }}><button className="defaultButton">Voltar para o site</button></Link>
                </aside></>
            }
          /></div>
        ) : (<Container>
          <Form ref={formRef} initialData={initialData} onSubmit={handleNewLogin} style={{ maxWidth: '800px' }}>
            <h1>{authTitle}</h1>
            <p>Cadastro de Monitores</p>

            <Separator>


              <label>Dados do Monitor</label>
              <Input name="name" placeholder="Nome Completo" />
              <MaskedInput mask="999.999.999-99" name="document_number" placeholder="CPF" />

              <Input name="email" placeholder="Email" />
              <Input type="text" name="company" placeholder="Instituição" />
            </Separator>












            <Separator>
              <label>Disponibilidade de horários - mínimo de {submission?.monitor_hour_fields?.[0]?.minimun} horários</label>



              <CheckboxInputJSON name="hours" options={
                hours || []
              } placeholder="" />
            </Separator>

            {/*  <Separator>
              <label>3 - Número de resumos para avaliação</label>
              <CheckboxInput unique name="papers_numbers" options={
                [
                  { value : '5 a 8', id:'5 a 8', label: '5 a 8'},
                  { value : '9 a 11', id:'9 a 11', label: '9 a 11'},
                  { value : '12 a 14', id:'12 a 14', label: '12 a 14'}
                ]
              } placeholder="" />

            </Separator> */}






            {errorMessage && (
              <Error>
                {errorMessage.map((item, index) => (
                  <div key={`error${index}`}>
                    <MdError />
                    {item}
                  </div>
                ))}
              </Error>
            )}

            <aside style={{ display: 'flex', justifyContent: 'center' }}>
              <Button style={{ width: '100%' }} type="submit">
                Enviar
              </Button>
            </aside>

            <FixedResponse style={{ display: activeReview ? 'flex' : 'none' }}>
              <div>
                <h1>Revisão de dados</h1>

                <h2>Dados do Monitor</h2>
                <strong>Nome completo</strong><p>{submissionData?.name}</p>
                <strong>CPF</strong><p>{submissionData?.document_number}</p>
                <strong>Email</strong><p>{submissionData?.email}</p>

                <strong>Instituição</strong><p>{submissionData?.company}</p>



                <h2>Horários</h2>

                {submissionData?.hours?.map(hourValue => {
                  return <aside style={{ background: '#eee', padding: '5px', margin: '5px', color: '#333', width: 'auto' }}>{hourValue}</aside>
                })}



                <button className="buttonBigGreen" type="submit" style={{ width: '200px', padding: '15px' }}>Enviar</button>


                <button className="defaultButtonReverse" type="button" onClick={() => setActiveReview(false)}>Editar</button>
              </div>

            </FixedResponse>
          </Form>
        </Container>
        )}
      </aside>


    </>
  );
};

export default MonitorSubscription;

